import React from "react";
import { Card } from "@shopify/polaris";
import { getDeviceIcon, getBrowserIcon, getOSIcon } from "utils/browserIcons";

function CameraError({ check }) {
  if (!check?.hasOwnProperty("cameraError")) return null;

  const cameraError = check.cameraError;

  if (!cameraError) {
    return (
      <Card.Section title="Camera initialized">
        <p>Camera access allowed and started successfully.</p>
      </Card.Section>
    );
  }

  const mapping = {
    PermissionDeniedError: {
      title: "Permission Denied",
      message: "The customer needs to approve access to their device's camera.",
    },
    NotReadableError: {
      title: "Other apps or tabs using the camera",
      message:
        "The camera failed to start because one or more other apps or browser windows are using the camera. The customer needs to close the other apps using the camera in order to continue.",
    },
    OverconstrainedError: {
      title: "Camera not compatible",
      message:
        "The camera on this customer's device is not compatible with Real ID. This could be from an older device or from an out of date browser.",
    },
    DevicesNotFoundError: {
      title: "No camera on the device",
      message:
        "This customer's device does not have a camera. They can open the link on a mobile phone, or consider enabling manual uploads to allow the customer to upload photos.",
    },
  };

  const error = mapping[cameraError];

  return (
    <Card.Section title={error?.title || "Issue enabling the customer's camera"}>
      <p>
        {error?.message ||
          "Instruct the customer to allow the camera to be used, and to close all other apps that might be using the camera."}
      </p>
    </Card.Section>
  );
}

function UADetails({ check }) {
  const ua = check?.parsedUa;
  if (!ua) return null;
  const DeviceIcon = getDeviceIcon(ua?.device?.type);
  const BrowserIcon = getBrowserIcon(ua?.browser?.name);
  const OSIcon = getOSIcon(ua?.os?.name);

  return (
    <Card.Section>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          marginBottom: "8px",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            margin: "8px 0",
          }}
        >
          <DeviceIcon style={{ fontSize: "1.875rem", marginBottom: "8px" }} />
          {ua?.device?.type || "Desktop"}
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            margin: "8px 0",
          }}
        >
          <OSIcon style={{ fontSize: "1.875rem", marginBottom: "8px" }} />
          {ua?.os?.name || "Unknown"}
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            margin: "8px 0",
          }}
        >
          <BrowserIcon style={{ fontSize: "1.875rem", marginBottom: "8px" }} />
          {ua?.browser?.name || "Unknown"}
        </div>
      </div>
    </Card.Section>
  );
}

export default function BrowserDetails({ check }) {
  if (!check?.parsedUa) return null;
  return (
    <Card title="Browser details">
      <UADetails check={check} />
      <CameraError check={check} />
    </Card>
  );
}
